import { Navigate, type RouteObject } from "react-router";
import { CountingRoute } from "./[countingId]/counting-route";
import { CountingsIndexRoute } from "./_components/countings-index-route";
import { FirstCountingIndexRoute } from "./[countingId]/first-counting/first-counting-index-route";
import { SecondCountingIndexRoute } from "./[countingId]/second-counting/second-counting-index-route";
import { SampleOverviewIndexRoute } from "./[countingId]/sample-overview/sample-overview-index-route";

export const countingsRoutes: RouteObject[] = [
  {
    index: true,
    element: <CountingsIndexRoute />,
  },
  {
    path: ":countingId",
    element: <CountingRoute />,
    children: [
      {
        index: true,
        element: <Navigate to="first-counting" />,
      },
      {
        path: "first-counting",
        element: <FirstCountingIndexRoute />,
      },
      {
        path: "second-counting",
        element: <SecondCountingIndexRoute />,
      },
      {
        path: "sample-overview",
        element: <SampleOverviewIndexRoute />,
      },
    ],
  },
];
